const transfers = {
  transfer: "Transferir", // translated
  transfers: "Transferencias", // translated
  dateAndTime: "Fecha y hora", // translated
  transferFrom: "Transferido de", // translated
  duration: "Duración", // translated
  numOfPersons: "Número de personas", // translated
  baggageAllowance: "Franquicia de equipaje", // translated
  small: "Pequeño", // translated
  big: "Grande", // translated
  provider: "Proveedor", // translated
  vehicle: "Vehículo", // translated
  distance: "Distancia", // translated
  price: "Precio", // translated
  inboundJourney: "Viaje entrante", // translated
  outboundJourney: "Viaje de ida", // translated
  arrivalTime: "Hora de llegada", // translated
  flightDetails: "Detalles del vuelo", // translated
  inboundPickupDate: "Fecha de recogida entrante", // translated
  outboundPickupDate: "Fecha de recogida de salida", // translated
  travelInfo: "Información de viaje", // translated
  flightsInfo: "Información de vuelos", // translated
  airportYouAreFlyingFrom: "Aeropuerto desde el que vuelas", // translated
  airportYouAreFlyingTo: "Aeropuerto al que vuelas", // translated
  inboundFlightNumber: "Número de vuelo entrante", // translated
  outboundFlightNumber: "Número de vuelo de ida", // translated
  inboundAirlineName: "Nombre de la aerolínea entrante", // translated
  outboundAirlineName: "Nombre de la aerolínea saliente", // translated
  tripMode: "Modo de viaje", // translated
  airportToPoint: "Aeropuerto a punto", // translated
  pointToAirport: "Punto al aeropuerto", // translated
  roundTrip: "Ida y vuelta", // translated
  destinationPoint: "Punto de destino", // translated
  originPoint: "Punto de origen", // translated
  transferType: "Tipo de transferencia", // translated
  min: "mín.", // translated
  max: "máx.", // translated
  pieces: "Piezas", // translated
  cancelationIs: "la cancelación es", // translated
};


export default transfers;
